<template>
  <!-- One Launchpad user, with what the reviewer needs to judge the match and whether access will work (app sign-in, or ADAS IQ in Connect Copilot). -->
  <div class="custom-user">
    <div>
      <b>{{ user.username }}</b> <span class="text-muted">(Launchpad user {{ user.user }})</span>
      <span v-if="user.isInactive" class="badge bg-danger ms-1">Inactive</span>
      <span v-if="user.canUseAdasMapMobile" class="badge bg-success ms-1">Access on</span>
      <span v-else class="badge bg-light text-dark ms-1">Access off</span>
    </div>
    <div>
      {{ [user.firstName, user.lastName].filter(Boolean).join(' ') }}<span v-if="user.email"> &middot; {{ user.email }}</span>
    </div>
    <div>
      Location: {{ user.firmName || '-' }}<span v-if="user.firmNetsuiteId" class="text-muted"> (NetSuite {{ user.firmNetsuiteId }})</span>
    </div>
    <div v-if="user.corporateFirm && user.corporateFirm !== user.firm">
      Corporate: {{ user.corporateFirmName
      }}<span v-if="user.corporateNetsuiteId" class="text-muted"> (NetSuite {{ user.corporateNetsuiteId }})</span>
    </div>
    <div v-if="user.adasApp">ADAS Map: {{ user.adasApp }}</div>
    <div v-else-if="user.connectApp" data-test="connect-only">
      Connect Copilot: {{ user.connectApp }}
      <div class="small text-muted">No ADAS Map app: access means ADAS IQ inside Connect Copilot. The app itself can't sign this user in.</div>
    </div>
    <div v-else class="text-danger">No ADAS Map or Connect Copilot app on this location, so access would not work.</div>
  </div>
</template>
<script>
export default {
  name: 'UserSummary',
  props: {
    user: { type: Object, required: true }
  }
}
</script>
